import React, { useState, useEffect } from 'react';
import { saveAs } from "file-saver";
import Papa from "papaparse";

const AiAgentManagerList = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    fetch(`https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/ai_agent_manager/list?page=${page}&search=${search}`)
      .then(res => res.json())
      .then(data => {
        console.log("Fetched AI Agent Data:", data); // ✅ Log fetched data
        setData(data);
      })
      .catch(err => console.error("List error:", err));
  }, [search, page]);

  const handleExportJSON = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    saveAs(blob, "export.json");
  };

  const handleExportCSV = () => {
    const headers = Object.keys(data[0] || {});
    const csvRows = [headers.join(",")];
    data.forEach(item => {
      const row = headers.map(field => JSON.stringify(item[field] ?? "")).join(",");
      csvRows.push(row);
    });
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    saveAs(blob, "export.csv");
  };

  const exportFilteredCSV = () => {
    const csv = Papa.unparse(filteredData || data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "export.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...filters, [name]: value };
    setFilters(updated);
    const filtered = data.filter(row =>
      Object.keys(updated).every(k =>
        !updated[k] || String(row[k] || '').toLowerCase().includes(updated[k].toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleImportJSON = (e) => {
    const fileReader = new FileReader();
    fileReader.onload = (event) => {
      try {
        const imported = JSON.parse(event.target.result);
        fetch("https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/ai_agent_manager/import", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(imported)
        }).then(() => window.location.reload());
      } catch (err) {
        alert("Invalid JSON file");
      }
    };
    fileReader.readAsText(e.target.files[0]);
  };

  const handleExcelUpload = (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);
    fetch("https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/ai_agent_manager/import/excel", {
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        alert("Imported " + data.rows + " rows successfully.");
        window.location.reload();
      })
      .catch(() => alert("Invalid Excel format or error during upload."));
  };

  const handleTemplateDownload = () => {
    const headers = Object.keys(data[0] || { id: 1 });
    const csvContent = headers.join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleDelete = (id) => {
    fetch(`/api/ai_agent_manager/delete/${id}`, { method: 'DELETE' })
      .then(() => setData(data.filter(item => item.id !== id)))
      .catch(err => console.error("Delete error:", err));
  };

  const handleEdit = (id) => {
    const updatedField = prompt("Enter updated value:");
    if (updatedField) {
      fetch(`/api/ai_agent_manager/edit/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: updatedField })
      })
        .then(() => {
          alert("Edit successful");
          window.location.reload();
        })
        .catch(err => console.error("Edit error:", err));
    }
  };

  return (
    <div className='container my-4'>
      <h2>AI AGENT MANAGER List</h2>
      <input
        type="text"
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Search..."
      />

      <div className="mb-3 d-flex justify-content-end gap-2 flex-wrap">
        <button className="btn btn-outline-primary" onClick={handleExportJSON}>Export JSON</button>
        <button className="btn btn-outline-success" onClick={handleExportCSV}>Export CSV</button>
        <button className="btn btn-outline-secondary" onClick={exportFilteredCSV}>Export Filtered CSV</button>
        <button className="btn btn-outline-info" onClick={handleTemplateDownload}>Download Template</button>
        <input type="file" accept="application/json" onChange={handleImportJSON} />
        <input type="file" accept=".xlsx" onChange={handleExcelUpload} />
        <a className="btn btn-outline-info" href={`https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/static/templates/ai_agent_manager_template.csv`} download>
          Download Sample
        </a>
      </div>

      <table className='table table-striped table-bordered table-responsive'>
        <thead>
          <tr>
            <th>id</th><th>agent_name</th><th>role</th><th>status</th><th>data_source_connection</th>
            <th>agent_behavior_prompt</th><th>trigger_events</th><th>last_used</th><th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {(filteredData.length ? filteredData : data).map((item, index) => (
            <tr key={index}>
              <td>{item.id}</td><td>{item.agent_name}</td><td>{item.role}</td><td>{item.status}</td>
              <td>{item.data_source_connection}</td><td>{item.agent_behavior_prompt}</td>
              <td>{item.trigger_events}</td><td>{item.last_used}</td>
              <td>
                <button className="btn btn-sm btn-warning me-1" onClick={() => handleEdit(item.id)}>Edit</button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="d-flex justify-content-center align-items-center gap-3">
        <button className="btn btn-secondary" onClick={() => setPage(p => Math.max(1, p - 1))}>Previous</button>
        <span>Page: {page}</span>
        <button className="btn btn-secondary" onClick={() => setPage(p => p + 1)}>Next</button>
      </div>
    </div>
  );
};

export default AiAgentManagerList;